import { observer } from 'mobx-react';
import { Component } from 'react';
import { withOrderStore } from '../../context';
import { BRANCH_DELIVERY_TYPE, DELIVERY_TYPES, getOrderDeliveryType } from 'src/constants/deliveryTypes';
import { ORDER_DINE_IN_TYPE, ORDER_SECTIONS } from 'src/constants/order';
import Crumbs, { ICrumb } from 'src/view/components/Controls/Crumbs';
import { OrderStore } from '~/mobx/orderStore';

// @ts-ignore
@withOrderStore
@observer
export default class OrderNavigation extends Component<{ orderStore?: OrderStore }, {}> {
  get orderStore() {
    return this.props.orderStore!;
  }

  get links(): ICrumb[] {
    const links: ICrumb[] = [{ label: 'Order', value: ORDER_SECTIONS.ORDER }];
    const deliveryType: BRANCH_DELIVERY_TYPE | null = this.orderStore.order && getOrderDeliveryType(this.orderStore.order.delivery_type_code);

    if (deliveryType === DELIVERY_TYPES.DELIVERY) {
      links.push({ label: 'Delivery', value: ORDER_SECTIONS.DELIVERY });
    } else if (this.orderStore.order?.dinein?.dinein_delivery_type === ORDER_DINE_IN_TYPE.DINE_IN) {
      links.push({ label: 'dine_in', value: ORDER_SECTIONS.DINE_IN });
    } else if (deliveryType === DELIVERY_TYPES.PICKUP) {
      links.push({ label: this.orderStore.order?.curbside ? 'curbside' : 'Pickup', value: ORDER_SECTIONS.PICKUP });
    }

    links.push({ label: 'txt_details', value: ORDER_SECTIONS.DETAILS });

    return links;
  }

  render() {
    return <Crumbs crumbs={this.links} activeCrumb={this.orderStore.section} onClick={this.orderStore.setSection} translateLabel />;
  }
}
